import { every, findIndex, isEmpty } from 'lodash';

import * as types from './constants';
import { sorts } from '../../../../pages/MyCreators/routes/MyCreatorsList/components/ConnectedTab/sort';
import { generateQueryFromString, removeFromQueryString } from '../../../../utils/queryString';
import queryString from 'query-string';

export const initialState = {
  dataTable: [],
  allSelected: false,
  loading: false,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false,
  message: null,
  filters: [
    // { key: 'sort', filterTitle: 'Sort', selected: true, value: sorts.default }
  ]
};

function dedupeByUuidKeepOrder(list) {
  const seen = new Set();
  const out = [];
  for (const item of list) {
    const id = item?.uuid || item?.creator?.uuid || item?.key;
    if (!id) {
      out.push(item);
      continue;
    }
    if (!seen.has(id)) {
      seen.add(id);
      out.push(item);
    }
  }
  return out;
}

const actions = {
  // Get single page
  [types.GET_MY_CREATORS_CONNECTED_SCROLL_REQUEST]: state => ({
    ...state,
    loading: true,
    errors_api: {}
  }),

  [types.GET_MY_CREATORS_CONNECTED_SCROLL_DONE]: (state, { payload }) => {
    const incoming = payload.dataTable || [];
    const page = parseInt(payload.curr_page, 10) || 1;

    const merged =
      page <= 1
        ? incoming
        : dedupeByUuidKeepOrder([...(state.dataTable || []), ...incoming]);

    return {
      ...state,
      loading: false,
      dataTable: merged,
      count: payload.count,
      next: payload.next,
      previous: payload.previous,
      message: payload.message,
      curr_page: page
    };
  },

  [types.GET_MY_CREATORS_CONNECTED_SCROLL_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  [types.GET_MY_CREATORS_CONNECTED_SCROLL_RESET]: () => ({ ...initialState }),

  // Optimistic
  [types.MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_REMOVE]: (state, { payload }) => {
    const uuid = payload;
    return {
      ...state,
      dataTable: (state.dataTable || []).filter(x => (x.uuid || x.creator?.uuid) !== uuid),
      count: Math.max(0, (state.count || 0) - 1)
    };
  },

  [types.MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_ADD]: (state, { payload }) => {
    const row = payload;
    const id = row?.uuid || row?.creator?.uuid || row?.key;
    if (!id) return state;

    const exists = (state.dataTable || []).some(x => (x.uuid || x.creator?.uuid || x.key) === id);
    if (exists) return state;

    return {
      ...state,
      dataTable: [row, ...(state.dataTable || [])],
      count: (state.count || 0) + 1
    };
  },

  // Refresh
  [types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_REQUEST]: state => ({
    ...state,
    loading: true,
    errors_api: {}
  }),

  [types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    dataTable: payload.dataTable || [],
    count: payload.count,
    next: payload.next,
    previous: payload.previous,
    message: payload.message,
    curr_page: parseInt(payload.curr_page, 10) || state.curr_page
  }),

  [types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  // Operations
  [types.TOGGLE_MY_CREATORS_CONNECTED_SCROLL]: (state, { payload }) => {
    const newDataTable = state.dataTable.map(el => el.select.id === payload ? {
      ...el,
      select: { ...el.select, value: !el.select.value }
    } : el);

    const status = every(newDataTable, x => x.select.value);

    return {
      ...state,
      allSelected: status,
      dataTable: newDataTable
    };
  },

  [types.TOGGLE_ALL_MY_CREATORS_CONNECTED_SCROLL]: (state, { payload }) => {
    if (payload && payload.reset) {
      return {
        ...state,
        allSelected: false,
        dataTable: state.dataTable.map(el => ({
          ...el,
          select: { ...el.select, value: false }
        }))
      };
    } else {
      const status = every(state.dataTable, x => x.select.value);

      return {
        ...state,
        allSelected: !status,
        dataTable: state.dataTable.map(el => ({
          ...el,
          select: { ...el.select, value: !status }
        }))
      };
    }
  },

  [types.SET_MY_CREATORS_CONNECTED_SCROLL_FILTER]: (state, { payload }) => {
    const index = findIndex(state.filters, x => x.key === payload.key);
    const updatedFilters = [...state.filters];
    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      if (typeof updatedFilters[index].value === 'string' || Array.isArray(updatedFilters[index].value)) {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value);
      } else {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value.type);
      }
    }

    return {
      ...state,
      filters: updatedFilters,
      curr_page: 1
    };
  },

  [types.SET_MY_CREATORS_CONNECTED_SCROLL_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], ...filter, selected: true };
    });

    return {
      ...state,
      filters: updatedFilters,
      curr_page: 1,
      queryParsed: true
    };
  },

  [types.CLEAR_MY_CREATORS_CONNECTED_SCROLL_FILTERS]: (state, { payload: { filterToUpdate, mobile } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].selected = filterToUpdate.selected;
      }

      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return {
        ...state,
        filters: updatedFilters,
        curr_page: 1
      };
    } else {
      const query = generateQueryFromString(window.location.search);

      if (query.tab) {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}?${queryString.stringify({ tab: query.tab })}`);
      } else {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}`);
      }

      return {
        ...state,
        filters: [
          { key: 'sort', filterTitle: 'Sort By', selected: true, value: sorts.default }
        ],
        curr_page: 1
      };
    }
  },

  [types.MY_CREATORS_CONNECTED_SCROLL_SET_PAGE]: (state, { payload }) => ({
    ...state,
    curr_page: parseInt(payload, 10) || 1,
    queryParsed: true
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
